import React, { useState } from "react";
import { Card, Input, Button, Form, Collapse } from "antd";
import { EditOutlined, CheckOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";

const { Panel } = Collapse;

const messageData = {
  "afdb794c-0af7-11f0-aa2e-9600031a4f8a": "Message for UUID 1",
  "b1234567-89ab-cdef-0123-456789abcdef": "Message for UUID 2",
};

const initialData = {
  componentSteps: [
    {
      messageCode: "patient-confirmation",
      Description: "Message Section 1",
      message: "afdb794c-0af7-11f0-aa2e-9600031a4f8a",
      fallback1: "b1234567-89ab-cdef-0123-456789abcdef",
    },
    {
      messageCode: "patient-confirmation",
      Description: "Message Section 2",
      message: "afdb794c-0af7-11f0-aa2e-9600031a4f8a",
      fallback1: "b1234567-89ab-cdef-0123-456789abcdef",
      fallback2: "",
    },
  ],
};

const MessageComponent = () => {
  const [formData, setFormData] = useState(initialData);
  const [editing, setEditing] = useState({});
  const [uuidUpdates, setUuidUpdates] = useState({});

  const handleEditClick = (index, key) => {
    setEditing({ ...editing, [`${index}-${key}`]: true });
  };

  const handleUpdateClick = (index, key) => {
    const newUuid = uuidv4();
    const updatedData = { ...formData };
    messageData[newUuid] = messageData[updatedData.componentSteps[index][key]];
    updatedData.componentSteps[index][key] = newUuid;
    setFormData(updatedData);
    setUuidUpdates({ ...uuidUpdates, [updatedData.componentSteps[index][key]]: newUuid });
    setEditing({ ...editing, [`${index}-${key}`]: false });
  };

  return (
    <div style={{ maxWidth: 600, margin: "20px auto" }}>
      <Collapse defaultActiveKey={["0"]}>
        {formData.componentSteps.map((step, index) => (
          <Panel key={index} header={step.Description}>
            <Card bordered style={{ marginBottom: 20 }}>
              <Form layout="vertical">
                <Form.Item label="Message Code">
                  <Input value={step.messageCode} disabled />
                </Form.Item>
                {Object.keys(step)
                  .filter((key) => key.toLowerCase().includes("message") || key.startsWith("fallback"))
                  .map((key) => (
                    <Form.Item key={key} label={key.replace("fallback", "Fallback ")}>
                      <Input
                        value={messageData[step[key]] || ""}
                        disabled={!editing[`${index}-${key}`]}
                      />
                      {editing[`${index}-${key}`] ? (
                        <CheckOutlined
                          style={{ marginLeft: 8, cursor: "pointer" }}
                          onClick={() => handleUpdateClick(index, key)}
                        />
                      ) : (
                        <EditOutlined
                          style={{ marginLeft: 8, cursor: "pointer" }}
                          onClick={() => handleEditClick(index, key)}
                        />
                      )}
                    </Form.Item>
                  ))}
              </Form>
            </Card>
          </Panel>
        ))}
      </Collapse>
      <Button type="primary" onClick={() => console.log("Saved Data:", JSON.stringify(formData, null, 2))} style={{ marginTop: 20 }}>
        Save
      </Button>
      <pre>{JSON.stringify(uuidUpdates, null, 2)}</pre>
    </div>
  );
};

export default MessageComponent;
